import { Component } from '@angular/core';

@Component({
  selector: 'app-belak-coming-soon',
  templateUrl: './belak-coming-soon.component.html',
  styleUrls: ['./belak-coming-soon.component.css'],
  standalone: true,
})
export class BelakComingSoonComponent {

}
